'use strict';

angular.module('ClinicApp').controller('VerifyAppointmentModalCtrl', function(
  $scope,
  appointmentId,
  ClinicConfig,
  $modalInstance,
  $timeout,
  $state,
  IframeService,
) {
  if (!appointmentId) {
    throw new Error('appointmentId is required');
  }

  // The iframe element isn't guaranteed to be loaded when the Controller runs unless we use $timeout
  const setIframeSrc = (url) => {
    $timeout(() => {
      const iframeElement = document.querySelector('#js-verify-appointment-iframe');

      if (!iframeElement) {
        return;
      }

      iframeElement.src = encodeURI(url);
    });
  };

  const baseAppointmentUrl = `${ClinicConfig.CLINIC_APP_V4_URL}/#/appointment/${appointmentId}`;
  const verifyAppointmentUrl = `${baseAppointmentUrl}/verify`;

  setIframeSrc(verifyAppointmentUrl);

  $scope.closeVerifyAppointmentModal = () => {
    $modalInstance.close();
  };

  $scope.goToAppointmentManagement = () =>
    $state.go('clinic.appointment', {
      appointmentId,
      appointment: undefined,
    });

  // Set up the event listener
  IframeService.setupFunctionCallHandler($scope);
});
